import {injectable} from "inversify";
import "@/extensions/date.extensions";
import {ApiService} from "@/services/apiService";
import {AxiosError, AxiosResponse} from "axios";
import {SucceededOrNotResponse} from "@/types/responses";
import {IFavoriteDocumentService} from "@/injection/interfaces";

@injectable()
export class FavoriteDocumentService extends ApiService implements IFavoriteDocumentService {
  public async addToFavorite(id: string): Promise<SucceededOrNotResponse> {
    const response = await this._httpClient
      .post<string, AxiosResponse<any>>(
        `${process.env.VUE_APP_API_BASE_URL}/api/documents/${id}/favorite`,
        '{}',
        this.headersWithJsonContentType())
      .catch(function (error: AxiosError): AxiosResponse<any> {
        return error.response as AxiosResponse<any>
      });
    return response.data
  }

  public async removeFromFavorite(id: string): Promise<SucceededOrNotResponse> {
    const response = await this._httpClient.delete<
      string,
      AxiosResponse<SucceededOrNotResponse>
    >(`${process.env.VUE_APP_API_BASE_URL}/api/documents/favorites/${id}`)
      .catch(function (error: AxiosError): AxiosResponse<SucceededOrNotResponse> {
        return error.response as AxiosResponse<SucceededOrNotResponse>;
      });
    return response.data;
  }
}